import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_OUTLINE_BUTTONS, EDGE_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeOutlineButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineButton} span={EDGE_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn outline color="primary" id="Tooltip-40" className="btn-pill">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-40" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary</ToolTip>
          {EDGE_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonEdgeButton key={index} item={data} outline/>
          ))}
        </CardBody>
      </Card>
    );
};

export default EdgeOutlineButtons;
